/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-confusing-arrow */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './register.scss';
// @ts-ignore
import { Modal } from '@els/els-react--modal';
// @ts-ignore
import { TextInput, ValidatedTextInput } from '@els/els-react--text-input';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
import routes from '../../constants/routes';
import {
    validatePassword,
    PasswordRules,
} from '../../utils/password-validation';
import { checkIfUserIsRegistered, registerUser } from './register-thunk';
import {
    selectCheckIfUserIsRegisteredAsyncStatus,
    selectCheckIfUserIsRegistered,
    selectRegisterUserAsyncStatus,
} from './register-selector';
import {
    hasFailed,
    isPending,
    hasSucceeded,
    isInitial,
} from '../../constants/async-status';
import { loginFlow } from '../login/login-thunk';

const Register = () => {
    const dispatch = useDispatch();
    const baseClassName = 'register';
    const email = decodeURIComponent(
        new URLSearchParams(window.location.search).get('email') || ''
    );
    const isUserRegistered = useSelector(selectCheckIfUserIsRegistered);
    const isUserRegisteredAsyncStatus = useSelector(
        selectCheckIfUserIsRegisteredAsyncStatus
    );
    const registerResponseAsyncStatus = useSelector(
        selectRegisterUserAsyncStatus
    );
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const passwordRules: PasswordRules = {
        minimumLength: 8,
        required: true,
        requireCapitalLetters: true,
        requireNumbers: true,
        requireSmallLetters: true,
        requireSpecialCharacters: true,
        minimumTypesRequired: 3,
    };
    const passwordErrors = passwordRules
        ? validatePassword(password, passwordRules)
        : [];
    const passwordsMatch = password === confirmPassword;
    const isValid = Boolean(
        passwordErrors.length === 0 &&
            passwordsMatch &&
            password &&
            confirmPassword
    );
    const [submittingError, setSubmittingError] = useState(false);

    useEffect(() => {
        dispatch(checkIfUserIsRegistered(email));
    }, [dispatch, email]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSubmittingError(false);
        if (!isValid || isSubmitting) return;

        setIsSubmitting(true);
        dispatch(registerUser({ email, password }));
    };

    useEffect(() => {
        if (hasSucceeded(registerResponseAsyncStatus)) {
            dispatch(loginFlow());
        }
        if (hasFailed(registerResponseAsyncStatus)) {
            setIsSubmitting(false);
            setSubmittingError(true);
        }
    }, [dispatch, registerResponseAsyncStatus]);

    if (isUserRegistered === true || hasFailed(isUserRegisteredAsyncStatus)) {
        return <Redirect to={routes.WELCOME} />;
    }

    if (
        isPending(isUserRegisteredAsyncStatus) ||
        isInitial(isUserRegisteredAsyncStatus)
    ) {
        return <Loader isVisible isBlocking />;
    }

    return (
        <Modal
            onClose={() => {}}
            shouldCloseOnEscape={false}
            shouldPreventClickOverlayToClose
            shouldHideCloseButton
        >
            <div className={baseClassName}>
                <div className={`${baseClassName}_heading`}>
                    <h2 className={`${baseClassName}_heading-title`}>
                        Join Elsevier | Clinical Learning Hub
                    </h2>
                    <p>Create a password to complete your registration</p>
                </div>
                <div className={`${baseClassName}_form`}>
                    <div className={`${baseClassName}_form-inputs`}>
                        <TextInput
                            value={email}
                            label="Email address"
                            disabled
                            required
                        />
                        <ValidatedTextInput
                            value={password}
                            label="Create password"
                            onChange={(e: any) => setPassword(e.target.value)}
                            type="password"
                            placeholder="Enter password"
                            autoComplete="off"
                            required
                            max={256}
                            disabled={isSubmitting}
                            validator={(pwd: string) => {
                                const errors = validatePassword(
                                    pwd,
                                    passwordRules
                                );
                                return errors.length > 0 ? errors[0] : null;
                            }}
                        />
                        <ValidatedTextInput
                            value={confirmPassword}
                            label="Confirm password"
                            onChange={(e: any) =>
                                setConfirmPassword(e.target.value)
                            }
                            type="password"
                            placeholder="Please reenter your password"
                            autoComplete="off"
                            required
                            max={256}
                            disabled={isSubmitting}
                            validator={(pwd: string) =>
                                pwd !== password
                                    ? 'Passwords do not match.'
                                    : null
                            }
                        />
                    </div>
                    <p className={`${baseClassName}_agreement`}>
                        By continuing, you agree with our{' '}
                        <a href="https://www.elsevier.com/legal/elsevier-website-terms-and-conditions">
                            Terms and Conditions
                        </a>{' '}
                        and{' '}
                        <a href="https://www.elsevier.com/legal/privacy-policy">
                            Privacy Policy
                        </a>
                        .
                    </p>
                    <Button
                        htmlType="submit"
                        disabled={!isValid || isSubmitting}
                        expanded
                        onClick={(e: any) => {
                            handleSubmit(e);
                        }}
                    >
                        {isSubmitting
                            ? 'Creating account...'
                            : 'Start exploring!'}
                    </Button>
                    {submittingError && (
                        <span
                            className="c-els-field__message--error register_submit-error"
                            role="alert"
                        >
                            An account already exists for {email}. Try{' '}
                            <a href="/welcome">logging in</a> instead.
                        </span>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default Register;
